import React from 'react'
import Header from '../../Component/Header'
import Footer from '../../Component/Footer'
import Awards from '../Awards'

export default function LayoutAwards() {
  return (
    <>
      <Header/>
      <Awards/>
      <Footer/>
    </>
  )
}
